var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"first"},[_c('Land',[_c('div',[_vm._v("123")])]),_c('Human'),_c('Tips')],1)}
var staticRenderFns = []

export { render, staticRenderFns }